import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { addTeamMutation, updateTeamMutation, getTeamsQuery } from '../../../queries/queries';
import { Form, Field, Group } from '../../../common/index';

function TeamForm(props) {
  const { content, associationData, onComplete } = props;
  const [sContent, setSContent] = useState(content);

  const ss = (c) => setSContent({ ...sContent, ...c });

  useEffect(() => {
    // Load bank information from bankInformation if available
    if (content.bankInformation) {
      setSContent(prev => ({
        ...prev,
        clearingNumber: content.bankInformation.clearingNumber || '',
        accountNumber: content.bankInformation.accountNumber || '',
        accountOwner: content.bankInformation.accountOwner || '',
      }));
    }
  }, [content.bankInformation]);

  useEffect(() => {
    if (content._id && sContent.useAssociationPaymentInfo === true && associationData?.association) {
      // If "same as association" is selected, copy association payment info
      setSContent(prev => ({
        ...prev,
        clearingNumber: associationData.association.bankInformation?.clearingNumber || '',
        accountNumber: associationData.association.bankInformation?.accountNumber || '',
        accountOwner: associationData.association.bankInformation?.accountOwner || '',
      }));
    } else if (content._id && sContent.useAssociationPaymentInfo === false) {
      // If "custom payment info" is selected, load team's own bank information (or empty if none exists)
      setSContent(prev => ({
        ...prev,
        clearingNumber: content.bankInformation?.clearingNumber || '',
        accountNumber: content.bankInformation?.accountNumber || '',
        accountOwner: content.bankInformation?.accountOwner || '',
      }));
    }
  }, [sContent.useAssociationPaymentInfo, associationData, content._id, content.bankInformation]);

  const formatDate = (date) => {
    const parsedDate = new Date(date);
    return isNaN(parsedDate) ? '' : parsedDate.toISOString().slice(0, 10);
  }

  return (
    <tr key={content ? content._id : 'new'} className="open">
      <td colSpan="100">
        <Form
          sContent={{
            ...sContent,
            // Transform the bank fields into bankInformation object
            bankInformation: sContent.clearingNumber || sContent.accountNumber || sContent.accountOwner ? {
              clearingNumber: sContent.clearingNumber || null,
              accountNumber: sContent.accountNumber || null,
              accountOwner: sContent.accountOwner || null,
            } : null,
            // Remove the individual fields so they don't get sent to the mutation
            clearingNumber: undefined,
            accountNumber: undefined,
            accountOwner: undefined,
          }}
          parent="associationId"
          get={getTeamsQuery}
          add={addTeamMutation}
          update={updateTeamMutation}
          onComplete={onComplete}
        >
          <Group title="Allmänt">
            <Field type="text" x2 req name="name" title="Lagnamn" value={sContent.name} onChange={ss} />
          </Group>
          <Group title="Försäljning">
            <Field
              type="date"
              name="salesStartDate"
              title="Första försäljningsdag"
              value={sContent && formatDate(sContent.salesStartDate)}
              onChange={ss}
            />
            <Field
              type="date"
              name="salesEndDate"
              title="Sista försäljningsdag"
              value={sContent && formatDate(sContent.salesEndDate)}
              onChange={ss}
            />
          </Group>
          <Group title="Betalningsuppgifter">
            <Field
              type="selectStatic"
              name="useAssociationPaymentInfo"
              title="Samma betalningsuppgifter som föreningen/skolan"
              value={sContent.useAssociationPaymentInfo}
              onChange={ss}
              selectData={[
                { value: true, label: 'Ja' },
                { value: false, label: 'Nej' }
              ]}
              x2
            />
            <Field
              type="text"
              name="clearingNumber"
              title="Clearingnummer"
              value={sContent.clearingNumber || ''}
              onChange={ss}
              disabled={sContent.useAssociationPaymentInfo === true}
            />
            <Field
              type="text"
              name="accountNumber"
              title="Kontonummer"
              value={sContent.accountNumber || ''}
              onChange={ss}
              disabled={sContent.useAssociationPaymentInfo === true}
            />
            <Field
              type="text"
              name="accountOwner"
              title="Ägare av konto"
              value={sContent.accountOwner || ''}
              onChange={ss}
              disabled={sContent.useAssociationPaymentInfo === true}
            />
          </Group>
          <Group title="Inställningar">
            <Field type="admins" x2 name="adminEmails" title="Lagledarens e-post" value={sContent.adminEmails} onChange={ss} />
            {sContent._id && (
              <Field
                type="text"
                name="slug"
                title="URL-slug"
                value={sContent.slug}
                onChange={ss}
              />
            )}
          </Group>
        </Form>
      </td>
    </tr>
  );
}

TeamForm.propTypes = {
  content: PropTypes.object.isRequired,
  associationData: PropTypes.object,
  userData: PropTypes.object,
  onComplete: PropTypes.func.isRequired,
};

export default TeamForm;
